import { render } from "./FeatureArea.vue?vue&type=template&id=7fb362c2"
import script from "./FeatureArea.vue?vue&type=script&lang=js"
export * from "./FeatureArea.vue?vue&type=script&lang=js"

import "./FeatureArea.vue?vue&type=style&index=0&id=7fb362c2&lang=scss"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3586\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__